import { render, staticRenderFns } from "./TaxAgency.vue?vue&type=template&id=4dc9496a&scoped=true"
import script from "./TaxAgency.vue?vue&type=script&lang=js"
export * from "./TaxAgency.vue?vue&type=script&lang=js"
import style0 from "./TaxAgency.vue?vue&type=style&index=0&id=4dc9496a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9496a",
  null
  
)

export default component.exports